/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo window
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Window = kendo.ui.Window;
    if (!Window || Window.updated) return;

    var WINDOW = ".k-window",
        TITLE = ".k-window-title",
        BAR = TITLE + "bar",
        TITLELESS = "k-window-titleless",
        CONTENT_FRAME = "k-content-frame",
        CONTENT = ".k-window-content",
        WINDOW_WITH_WIDTH = "k-window-with-width",
        OVERLAY = "overlay",
        CLICK = "click",
        ACTIVATE = "activate",
        DEACTIVATE = "deactivate",
        OPEN = "open",
        REFRESH = "refresh",
        VISIBLE = ":visible",
        OVERFLOW = "overflow",
        HIDDEN = "hidden",
        CURSOR = "cursor",
        POINTER = "pointer",
        OPACITY = "opacity",
        DEFAULT_OPACITY = 0.5,
        Z_INDEX = "zIndex",
        proxy = $.proxy,
        // TODO : option for this ?
        autoCenterEvents = [ACTIVATE, OPEN, REFRESH],
        template = kendo.template,
        // same templates as original
        // TODO : template options
        templates = {
            wrapper: template("<div class='k-widget k-window' />"),
            action: template(
                "<a role='button' href='\\#' class='k-window-action k-link'>" +
                "<span role='presentation' class='k-icon k-i-#= name.toLowerCase() #'>#= name #</span>" +
                "</a>"
            ),
            titlebar: template(
                "<div class='k-window-titlebar k-header'>&nbsp;" +
                "<span class='k-window-title'>#= title #</span>" +
                "<div class='k-window-actions' />" +
                "</div>"
            ),
            overlay: "<div class='k-overlay' />",
            contentFrame: template(
                "<iframe frameborder='0' title='#= title #' class='" + CONTENT_FRAME + "' src='#= content.url #'>" +
                "This page requires frames in order to show content." +
                "</iframe>"
            ),
            resizeHandle: template("<div class='k-resize-handle k-resize-#= data #'></div>")
        };

    function windowDeactivate() {
        var self = this;
        self.wrapper.hide().css(OPACITY, "");
        self.trigger(DEACTIVATE);
        if (!self.options.showOverlay) return;
        if (self.options.modal) {
            var lastModal = self._object(self._modals().last());
            if (lastModal) {
                lastModal.toFront();
            }
        }
    }

    /**
     * Dialogue auto-centering on document resize ( and probably also device rotation ) events.
     */
    var oldDocumentResize = Window.fn._onDocumentResize;
    function windowDocumentResize() {
        var self = this;
        oldDocumentResize.call(self);
        var isVisible = this.element[0].offsetParent !== null;
        if (self.options.autoCenter && !self.options.isMaximized && isVisible) self.center();
    }

    /**
     * TODO : solve the opacity only via styles
     */
    function windowOpen() {
        var self = this,
            wrapper = self.wrapper,
            options = self.options,
            showOptions = this._animationOptions('open'),
            contentElement = wrapper.children(CONTENT),
            overlay,
            otherModalsVisible,
            doc = $(document);

        if (!self.trigger(OPEN)) {
            if (self._closing) {
                wrapper.kendoStop(true, true);
            }
            self._closing = false;
            self.toFront();
            if (options.autoFocus) {
                self.element.focus();
            }
            options.visible = true;
            // This part was executed for modal option in old code version.
            if (options.showOverlay) {
                overlay = self._overlay(false);
                overlay.kendoStop(true, true);
                if (showOptions.duration && kendo.effects.Fade) {
                    var overlayFx = kendo.fx(overlay).fadeIn();
                    overlayFx.duration(showOptions.duration || 0);
                    overlayFx.play();
                }
                overlay.show();
            }
            if (options.modal) {
                otherModalsVisible = !!self._modals().length;
                overlay = self._overlay(otherModalsVisible);
                overlay.kendoStop(true, true);
                if (showOptions.duration && kendo.effects.Fade && !otherModalsVisible) {
                    var overlayFx = kendo.fx(overlay).fadeIn();
                    overlayFx.duration(showOptions.duration || 0);
                    overlayFx.play();
                }
                overlay.show();
                $(window).on('focus', function () {
                    if (contentElement.data('isFront')) {
                        self.element.focus();
                    }
                });
            }
            if (!wrapper.is(VISIBLE)) {
                contentElement.css(OVERFLOW, HIDDEN);
                wrapper.show().kendoStop().kendoAnimate({
                    effects: showOptions.effects,
                    duration: showOptions.duration,
                    complete: proxy(this._activate, this)
                });
            }
        }
        if (options.isMaximized) {
            self._documentScrollTop = doc.scrollTop();
            self._documentScrollLeft = doc.scrollLeft();
            $("html, body").css(OVERFLOW, HIDDEN); // TODO : OK for all cases ?
        }
        return self;
    }

    var oldOverlay = Window.fn._overlay;
    function windowOverlay(visible) {
        var self = this,
            $overlay = oldOverlay.call(self, visible);
        if ($overlay && $overlay.length) {
            var modal = self.options.modal || false,
                eventName = CLICK + "." + OVERLAY;
            $overlay
                .off(eventName)
                .css(CURSOR, modal ? "" : POINTER);
            if (!modal)
                $overlay.on(eventName, function () {
                    self._close(false);
                });
        }
        return $overlay;
    }

    function windowRemoveOverlay(suppressAnimation) {
        var self = this,
            modals = self._modals(),
            options = self.options,
            hideOverlay = options.showOverlay && !modals.length,
            overlay = options.showOverlay ? self._overlay(true) : $(undefined),
            hideOptions = this._animationOptions('close');
        if (hideOverlay) {
            if (!suppressAnimation && hideOptions.duration && kendo.effects.Fade) {
                var overlayFx = kendo.fx(overlay).fadeOut();
                overlayFx.duration(hideOptions.duration || 0);
                overlayFx.startValue(0.5);
                overlayFx.play();
            } else {
                self._overlay(false).remove();
            }
        } else if (modals.length) {
            self._object(modals.last())._overlay(true);
        }
    }

    var oldSetOptions = Window.fn.setOptions;
    function windowSetOptions(options) {
        var self = this,
            NS = ".autoCenter",
            EVENTS = autoCenterEvents.join(NS + " ") + NS;
        if (options.modal) options.showOverlay = true;
        oldSetOptions.call(self, options);
        // TODO : following didn't work, so overriding the trigger() method
        // maybe we could override rather the Widget.trigger(), so that we
        // can namespace all Kendo events like jQuery events, but that will
        // be more complex & may break some default functionality
        //if( self.options.autoCenter )
        //    self.bind( EVENTS, self.center );
        //else
        //    self.unbind( NS );
    }

    function windowTitle(text) {
        var self = this,
            wrapper = self.wrapper,
            options = self.options,
            titleBar = wrapper.children(BAR),
            title = titleBar.children(TITLE),
            titleBarHeight;
        if (!arguments.length) {
            return title.html();
        }
        if (!titleBar.length) {
            wrapper.prepend(templates.titlebar(options));
            self._actions();
            titleBar = wrapper.children(BAR);
        } else {
            title.html(kendo.htmlEncode(text));
        }
        if (text === false) {
            wrapper.addClass(TITLELESS);
        } else {
            wrapper.removeClass(TITLELESS);
            titleBarHeight = parseInt(kendo._outerHeight(titleBar), 10);
            wrapper.css("padding-top", titleBarHeight);
            titleBar.css("margin-top", -titleBarHeight);
        }
        self.options.title = text;
        return self;
    }

    /**
     * Dialogue auto-centering on some component events done here for now.
     */
    var oldTrigger = Window.fn.trigger;
    function windowTrigger(eventName, event) {
        var self = this;
        if (self.options.autoCenter && autoCenterEvents.indexOf(eventName) > -1) self.center();
        oldTrigger.call(self, eventName, event);
    }

    /**
     * Originally, this was _modals method. But now we can have an overlay
     * also for non-modal dialogue. So it is actually rather overlays.
     * The functionality is probably like there should be only one overlay
     * at a time even if more windows are opened. When last window with overlay
     * closes, overlay has to be removed. So we need such function to get
     * all opened windows with overlays.
     */
    function visibleWindowsWithOverlays() {
        var self = this,
            zStack = $(WINDOW)
                .filter(function () {
                    var dom = $(this),
                        object = self._object(dom),
                        options = object && object.options;
                    // not sure if this is needed
                    if (options && options.showOverlay) {
                        return options && options.showOverlay && options.visible && options.appendTo === self.options.appendTo && dom.is(VISIBLE);
                    } else {
                        return options && options.modal && options.visible && options.appendTo === self.options.appendTo && dom.is(VISIBLE);
                    }
                })
                .sort(function (a, b) {
                    return +$(a).css(Z_INDEX) - +$(b).css(Z_INDEX);
                });
        self = null;
        return zStack;
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. New init function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so the
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldWindowInit = Window.fn.init,
        newWindowInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "window", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            // call original constructor
            oldWindowInit.call(self, element, options);
            if (options.visible && options.showOverlay)
                self._overlay(self.wrapper.is(VISIBLE)).css({ OPACITY: DEFAULT_OPACITY });
            if (options.width)
                self.wrapper.addClass(WINDOW_WITH_WIDTH);
        };

    Window = Window.extend({
        // new init
        init: newWindowInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions({
            autoCenter: true,
            showOverlay: true,
            resizable: false,
            draggable: false
        }),
        // updated methods
        _deactivate: windowDeactivate,
        _modals: visibleWindowsWithOverlays,
        _onDocumentResize: windowDocumentResize,
        open: windowOpen,
        _overlay: windowOverlay,
        _removeOverlay: windowRemoveOverlay,
        setOptions: windowSetOptions,
        title: windowTitle,
        trigger: windowTrigger
    });

    Window.updated = true;

    kendo.ui.plugin(Window);

})(window.kendo.jQuery);
